export const parseFileName = (url) => {
  if (!url) return "";
  const parts = url.split("/");
  const filename = parts[parts.length - 1].split("?")[0];
  return {
    name: filename.substring(0, filename.lastIndexOf(".")),
    ext: filename.substring(filename.lastIndexOf(".")),
  };
};
